import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const originalFetch = window.fetch.bind(window);
window.fetch = ((input: RequestInfo, init: RequestInit = {}) => {
  const mergedInit: RequestInit = {
    ...init,
    credentials: init.credentials ?? "include",
  };
  return originalFetch(input, mergedInit);
}) as typeof window.fetch;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
